<template>
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_protective_coating_notes_interior_girder_beam`"
    :inspectionCommentType="INSPECTION_COMMENTS.INTERIOR_BEAM_GIRDER"
    :readOnly="!isEditable"
    label="Interior Girder/Beam"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_protective_coating_notes_fascia`"
    :inspectionCommentType="INSPECTION_COMMENTS.PAINT_FASCIAS"
    :readOnly="!isEditable"
    label="Fascia"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_protective_coating_notes_splash_zone_truss_girder`"
    :inspectionCommentType="INSPECTION_COMMENTS.PAINT_SPLASH_ZONE"
    :readOnly="!isEditable"
    label="Splash Zone - Truss/Girder"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_protective_coating_notes_truss`"
    :inspectionCommentType="INSPECTION_COMMENTS.PAINT_TRUSS"
    :readOnly="!isEditable"
    label="Truss"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_protective_coating_notes_bearing`"
    :inspectionCommentType="INSPECTION_COMMENTS.PAINT_BEARINGS"
    :readOnly="!isEditable"
    label="Bearing"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_protective_coating_notes_other`"
    :inspectionCommentType="INSPECTION_COMMENTS.PAINT_OTHER"
    :readOnly="!isEditable"
    label="Other"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
</template>
<script setup>
import { computed, toRefs } from "vue";
import { useConfigStore } from "@/stores/config";
import { useSuperstructureStore } from "@/components/inspection/store/superStructure";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import StructureUnitCommentTypeTextField from "@/components/inspection/spanBySpanComponents/StructureUnitCommentTypeTextField.vue";
import { INSPECTION_COMMENTS, INSPECTION_PAGES } from "@/constants/Inspections";
import { storeToRefs } from "pinia";

const props = defineProps({
  structureUnitId: Number,
});
const { structureUnitId } = toRefs(props);
const store = useSuperstructureStore();
const { isEditable, isDirty } = storeToRefs(store);
const configStore = useConfigStore();
const commentsMaxLength = computed(() => {
  return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
});
</script>
